$('.owl-carousel').owlCarousel({
  loop: true,
  margin: 10,
  nav: true,
  dotsEach: true,
  autoWidth: true,
  animateIn: true,
  animateOut: true,
  navText: [
    "<div class='nav-button owl-prev'>‹</div>",
    "<div class='nav-button owl-next'>›</div>",
  ],
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 2,
    },
  },
});

const destroyCarouselOnPageLeave = function () {
  $('.owl-carousel').trigger('destroy.owl.carousel');
};

const carouselItems = document.getElementsByClassName('owl-item');
for (const elem of carouselItems) {
  elem.addEventListener('click', destroyCarouselOnPageLeave);
}
